import * as yup from "yup";

const isSupplementTutor = (task, category) =>
  task === "Gia sư" && category === "Gia sư bổ trợ";

export const TutorTaskSchema = {
  // Tác vụ: luôn bắt buộc
  tac_vu: yup
    .string()
    .required("Tác vụ không được để trống")
    .matches(/^[A-Za-zÀ-ỹ\s]+$/, "Tác vụ không hợp lệ. Vui lòng chỉ nhập chữ cái và khoảng trắng."),

  // Phân loại: chỉ bắt buộc khi tac_vu !== 'Tác vụ khác'
  phan_loai: yup
    .string()
    .matches(/^[A-Za-zÀ-ỹ\s]+$/, {
      message: "Phân loại không hợp lệ. Vui lòng chỉ nhập chữ cái và khoảng trắng.",
      excludeEmptyString: true,
    })
    .when("tac_vu", {
      is: (val) =>{console.log(val);
       return val !== "Tác vụ khác" } ,
      then: (schema) => schema.required("Phân loại không được để trống"),
      otherwise: (schema) => schema.notRequired(),
    }),

  // Mã lớp
  ma_lop: yup
    .string()
    .when("tac_vu", {
      is: (val) => val !== "Tác vụ khác",
      then: (schema) => schema.required("Mã lớp không được để trống"),
      otherwise: (schema) => schema.notRequired(),
    }),

  // Nội dung gia sư
  noi_dung_gia_su: yup
    .string()
    .when(["tac_vu", "phan_loai"], {
      is: (task, category) => task !== "Tác vụ khác" && !isSupplementTutor(task, category),
      then: (schema) => schema.required("Nội dung gia sư không được để trống"),
      otherwise: (schema) => schema.notRequired(),
    }),

  // Link zalo lớp đệm
  link_zalo_lop_dem: yup
    .string()
    .url("Link Zalo không hợp lệ. Vui lòng nhập URL hợp lệ.")
    .when(["tac_vu", "phan_loai"], {
      is: (task, category) => task !== "Tác vụ khác" && !isSupplementTutor(task, category),
      then: (schema) =>
        schema.required("Link Zalo lớp đệm không được để trống"),
      otherwise: (schema) => schema.notRequired(),
    }),

  so_luong_hoc_vien: yup
    .number()
    .nullable() 
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    ) 
    .when(["tac_vu", "phan_loai"], {
      is: (task, category) => 
        task === "Tác vụ khác" || category === "Gia sư lớp đệm",
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => 
        schema.when(["tac_vu", "phan_loai"], {
          is: isSupplementTutor,
          then: (s) => s
            .required("Số lượng học viên không được để trống")
            .typeError("Số lượng học viên phải là số nguyên.")
            .integer("Số lượng học viên phải là số nguyên.")
            .min(1, "Số lượng học viên phải lớn hơn 0."),
          otherwise: (s) => s.notRequired(),
        })
    }),

  link_zalo_lop_ho_tro: yup
    .string()
    .url("Link Zalo lớp hỗ trợ không hợp lệ. Vui lòng nhập URL hợp lệ.")
    .when(["tac_vu", "phan_loai"], {
      is: isSupplementTutor,
      then: (schema) => schema.required("Link Zalo lớp hỗ trợ không được để trống"),
      otherwise: (schema) => schema.notRequired(),
    }),

  // Các field khác giữ nguyên
  doi_tuong_xu_ly: yup
    .string()
    .when("tac_vu", {
      is: "Tác vụ khác",
      then: (schema) => schema.required("Đối tượng xử lý không được để trống"),
      otherwise: (schema) => schema.notRequired(),
    }),

  ngay_lam: yup
    .string()
    .required("Ngày làm không được để trống")
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/,
      "Ngày làm không hợp lệ. Vui lòng nhập theo định dạng DD-MM-YYYY."
    ),

  thoi_gian_lam: yup
    .string()
    .required("Thời gian làm không được để trống")
    .matches(
      /^([01]\d|2[0-3]):[0-5]\d\s*-\s*([01]\d|2[0-3]):[0-5]\d$/,
      "Thời gian làm không hợp lệ. Vui lòng nhập theo định dạng HH:MM - HH:MM."
    ),
}
